import { useState } from 'react';
import { supabase } from '../supabase';

function Auth({ onLogin }) {
  const [mode, setMode] = useState('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async () => {
    setLoading(true);
    setError('');
    setMessage('');

    // Reset mode only needs an email — everything else needs email + password.
    if (mode === 'reset') {
      if (!email) {
        setError('Please enter your email.');
        setLoading(false);
        return;
      }
    } else if (!email || !password) {
      setError('Please enter your email and password.');
      setLoading(false);
      return;
    }

    if (mode === 'login') {
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) {
        setError(error.message);
      }
    } else if (mode === 'signup') {
      const { error } = await supabase.auth.signUp({ email, password });
      if (error) {
        setError(error.message);
      } else {
        setMessage('Account created! Check your email to confirm your account, then log in.');
        setMode('login');
      }
    } else if (mode === 'reset') {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: window.location.origin,
      });
      if (error) {
        setError(error.message);
      } else {
        setMessage('Password reset email sent! Check your inbox.');
        setMode('login');
      }
    }

    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '16px',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '400px',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        overflow: 'hidden'
      }}>
        {/* Header */}
        <div style={{
          background: 'linear-gradient(135deg, #1a1a2e 0%, #2d2d5e 100%)',
          padding: '32px 24px',
          textAlign: 'center'
        }}>
          <img src={require('../BYG_with_background_color.png')} alt="BYG" style={{ height: '60px', marginBottom: '12px' }} />
          <h1 style={{ color: 'white', fontSize: '20px', margin: '0 0 4px' }}>BYG Deal Desk</h1>
          <p style={{ color: '#c9a84c', fontSize: '13px', margin: 0 }}>Real Estate, Tax Deed and Lien Investing</p>
        </div>

        {/* Form */}
        <div style={{ padding: '24px' }}>
          <h2 style={{ fontSize: '18px', color: '#1a1a2e', marginBottom: '20px', textAlign: 'center' }}>
            {mode === 'login' ? 'Sign In' : mode === 'signup' ? 'Create Account' : 'Reset Password'}
          </h2>

          {error && (
            <div style={{ backgroundColor: '#fff0f0', border: '1px solid #ffcccc', borderRadius: '6px', padding: '10px 12px', marginBottom: '16px', fontSize: '13px', color: '#c0392b' }}>
              {error}
            </div>
          )}

          {message && (
            <div style={{ backgroundColor: '#f0fff4', border: '1px solid #b3e6c8', borderRadius: '6px', padding: '10px 12px', marginBottom: '16px', fontSize: '13px', color: '#2d6a4f' }}>
              {message}
            </div>
          )}

          <div style={{ marginBottom: '16px' }}>
            <label style={{ fontSize: '13px', color: '#555', fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@example.com"
              onKeyDown={e => e.key === 'Enter' && mode === 'reset' && handleSubmit()}
              style={{
                width: '100%', padding: '12px', border: '1px solid #ddd',
                borderRadius: '6px', fontSize: '16px', boxSizing: 'border-box'
              }}
            />
          </div>

          {mode !== 'reset' && (
            <div style={{ marginBottom: '20px' }}>
              <label style={{ fontSize: '13px', color: '#555', fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>Password</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Enter your password"
                onKeyDown={e => e.key === 'Enter' && handleSubmit()}
                style={{
                  width: '100%', padding: '12px', border: '1px solid #ddd',
                  borderRadius: '6px', fontSize: '16px', boxSizing: 'border-box'
                }}
              />
            </div>
          )}

          <button
            onClick={handleSubmit}
            disabled={loading}
            style={{
              width: '100%', padding: '14px', backgroundColor: loading ? '#888' : '#c9a84c',
              color: '#1a1a2e', border: 'none', borderRadius: '6px',
              fontSize: '15px', fontWeight: 'bold', cursor: loading ? 'not-allowed' : 'pointer',
              marginBottom: '16px'
            }}
          >
            {loading ? 'Please wait...' : mode === 'login' ? 'Sign In' : mode === 'signup' ? 'Create Account' : 'Send Reset Email'}
          </button>

          <div style={{ textAlign: 'center', fontSize: '13px', color: '#555' }}>
            {mode === 'login' && (
              <div>
                <button onClick={() => { setMode('signup'); setError(''); setMessage(''); }}
                  style={{ background: 'none', border: 'none', color: '#1a1a2e', cursor: 'pointer', fontWeight: 'bold', fontSize: '13px' }}>
                  Create an account
                </button>
                <span style={{ margin: '0 8px', color: '#ccc' }}>|</span>
                <button onClick={() => { setMode('reset'); setError(''); setMessage(''); }}
                  style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', fontSize: '13px' }}>
                  Forgot password?
                </button>
              </div>
            )}
            {mode === 'signup' && (
              <button onClick={() => { setMode('login'); setError(''); setMessage(''); }}
                style={{ background: 'none', border: 'none', color: '#1a1a2e', cursor: 'pointer', fontWeight: 'bold', fontSize: '13px' }}>
                Already have an account? Sign in
              </button>
            )}
            {mode === 'reset' && (
              <button onClick={() => { setMode('login'); setError(''); setMessage(''); }}
                style={{ background: 'none', border: 'none', color: '#1a1a2e', cursor: 'pointer', fontWeight: 'bold', fontSize: '13px' }}>
                Back to sign in
              </button>
            )}
          <div style={{ marginTop: '20px', paddingTop: '16px', borderTop: '1px solid #eee', textAlign: 'center' }}>
  <p style={{ fontSize: '12px', color: '#aaa', margin: '0 0 10px' }}>Just exploring?</p>
  <button
    onClick={() => onLogin('guest')}
    style={{
      width: '100%', padding: '12px', backgroundColor: 'transparent',
      border: '1px solid #ddd', borderRadius: '6px',
      fontSize: '14px', color: '#888', cursor: 'pointer'
    }}
  >
    Continue as Guest
  </button>
</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Auth;
